interface GisErrorStateProps {
  onRetry: () => void
}

/** Mirrors the post-S1..S7 layout (map pane + ~40% Issues panel) so recovery causes no layout shift. */
export function GisLoadingSkeleton() {
  return (
    <div className="flex h-full min-h-0 bg-gis-bg">
      <div className="relative min-w-0 flex-1 animate-pulse bg-slate-200/60">
        <div className="absolute top-[18px] left-[18px] h-[42px] w-[300px] rounded-[12px] bg-white/70" />
        <div className="absolute bottom-[18px] left-1/2 h-[50px] w-[320px] -translate-x-1/2 rounded-[14px] bg-white/70" />
        <div className="absolute right-[18px] bottom-[18px] h-[200px] w-[236px] rounded-[14px] bg-white/70" />
      </div>
      <div className="flex w-[40%] min-w-[360px] flex-col border-l border-gis-line bg-gis-panel">
        <div className="flex-1 space-y-3.5 overflow-hidden p-3.5">
          {/* toolbar */}
          <div className="h-[34px] animate-pulse rounded-[10px] bg-slate-200/80" />
          {/* 3 status tiles */}
          <div className="flex gap-[7px]">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="h-[58px] flex-1 animate-pulse rounded-xl bg-slate-200/80" />
            ))}
          </div>
          {/* severity & load card */}
          <div className="h-[148px] animate-pulse rounded-2xl bg-slate-200/80" />
          {/* breakdown card (header + bars) */}
          <div className="space-y-3 rounded-2xl bg-slate-200/40 p-4">
            <div className="h-[30px] animate-pulse rounded-[10px] bg-slate-200/80" />
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-[11px] animate-pulse rounded-full bg-slate-200/80" />
            ))}
          </div>
        </div>
        {/* collapsed dock bar */}
        <div className="h-[52px] flex-none animate-pulse border-t border-gis-line bg-slate-200/70" />
      </div>
    </div>
  )
}

export function GisErrorState({ onRetry }: GisErrorStateProps) {
  return (
    <div className="grid h-full place-items-center">
      <div className="text-center">
        <p className="text-ink text-sm font-bold">Couldn&apos;t load the GIS overview</p>
        <p className="text-muted-text mt-1 text-xs">Check your connection and try again.</p>
        <button
          type="button"
          onClick={onRetry}
          className="bg-ink mt-3 rounded-lg px-4 py-2 text-xs font-semibold text-white hover:opacity-90"
        >
          Retry
        </button>
      </div>
    </div>
  )
}

export function GisEmptyState() {
  return (
    <div className="grid h-full place-items-center">
      <div className="text-center">
        <p className="text-ink text-sm font-bold">No GIS data for this selection</p>
        <p className="text-muted-text mt-1 text-xs">Try a different entity or date range.</p>
      </div>
    </div>
  )
}
